import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { IEnvironment } from 'src/environments/environment.model';

import { ConstructionUpdate, ConstructionUpdateReadReceipt } from 'src/app/modules/core/models/shr.model';
import { SettingsService } from 'src/app/modules/core/services/settings.service';

import { UnsubscribeOnDestroy } from 'src/app/modules/shared/utilities/unsubscribe-on-destroy';

@Injectable({
	providedIn: 'root'
})
export class ShrService extends UnsubscribeOnDestroy {	
	private settings!: IEnvironment;

	constructor(private _http: HttpClient,
		settingsService: SettingsService) {
		super();

		settingsService.getSettings().pipe(
			this.takeUntilDestroyed()
		).subscribe(settings => {
			this.settings = settings;
		});
	}

	getConstructionUpdates(salesAgreementId: number): Observable<ConstructionUpdate[]> {
		const url = `${this.settings?.apiUrl}shr/salesAgreement/${salesAgreementId}/constructionUpdates`;
		return this._http.get<ConstructionUpdate[]>(url);
	}

	insertConstructionUpdateReadReceipt(constructionUpdateReadReceipt: ConstructionUpdateReadReceipt) {
		const url = `${this.settings?.apiUrl}shr/constructionUpdateReadReceipt`;
		return this._http.post(url, constructionUpdateReadReceipt);
	}
}